<template>
<div>
    <HeaderContent header="จัดการรูปภาพหน้าเว็บไซต์" :img_header="header_image" link_back="content" />
    <MenuContentManageImage />
    <ContentSlideList />
</div>
</template>

<script>
import HeaderImage from '@/assets/picture.png'
import HeaderContent from '@/components/menuadmin/content/contentheader/HeaderContent.vue'
import MenuContentManageImage from '@/components/menuadmin/content/contentmanageimage/MenuContentManageImage.vue'
import ContentSlideList from '@/components/menuadmin/content/contentmanageimage/ContentSlideList.vue'

export default {
    name: 'contentSlide',
    components: {
        HeaderContent,
        MenuContentManageImage,
        ContentSlideList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>
